export default __webpack_public_path__ + "static/media/map-bg.68dedb73.jpg";